var _defs, _use, _use2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTruckinline = function SvgTruckinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 500"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "truck_inline_svg__a",
    d: "M56 0h338c31 0 56 28 56 62v63h38c17 0 33 9 44 23l56 77c8 12 12 25 12 40v89c0 35-25 63-56 63h-19c0 46-34 83-75 83s-75-37-75-83H188c0 46-34 83-75 83-42 0-75-37-75-83v-4c-23-9-38-32-38-59V62C17 21 36 0 56 0zm96 345c10 8 19 18 25 30h208c7-13 16-23 28-31V62c0-11-9-20-19-20H56c-10 0-18 9-18 20v292c-1 8 4 16 11 19 21-39 67-52 103-28zm363 30h29c10 0 19-9 19-21v-90c-1-4-2-9-5-13l-55-77c-4-4-9-7-15-7h-38v166c34 11 56 25 65 42zM75 417c0 23 17 41 38 41 20 0 37-18 37-41s-17-42-37-42c-21 0-38 19-38 42zm338 0c0 23 16 41 37 41s38-18 38-41-17-42-38-42-37 19-37 42z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#truck_inline_svg__a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "#000",
    strokeOpacity: 0,
    xlinkHref: "#truck_inline_svg__a"
  })));
};

export default SvgTruckinline;